/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useTranslation } from 'next-i18next';
import InvestorsTable from '../investors-table';
import styles from './investor-rss.module.scss';
import { ISecFillingEntry } from '@anghami/neogateway/dist/endpoints/getSecFilings';
import mainStyles from '../../../pages/investors/investors.module.scss';
import { getSeperateText } from '@helpers/helper';
import { combineCN } from '@helpers/styles.helper';

interface IProps {
	contents: ISecFillingEntry[];
}

const COMMS_EMAIL = 'comms@anghami.com';
const SEC_FILINGS_URL = 'https://www.sec.gov/edgar/browse/index.html?cik=1871983';

export default function SecFilings({ contents }: IProps) {
	const { t } = useTranslation();
	const { firstPart, highlighted } = getSeperateText(t('IR_landing_sec_disclaimer'), COMMS_EMAIL);

	return (
		<section
			id="investors-filings"
			className={combineCN(mainStyles.main_section_wrapper, 'd-flex f-column f-center')}
		>
			<h2 className={mainStyles.title}>{t('investor_relations_regulatory_filings')}</h2>
			<div className={styles.content_wrapper}>
				<div className={styles.subtitle}>{t('IR_landing_sec')}</div>
				<div className={styles.disclaimer}>
					{firstPart}&nbsp;
					<a href={`mailto:${COMMS_EMAIL}?subject=Investor%20relations`}>{highlighted}</a>
				</div>
				<div className={styles.desktopView}>
					<InvestorsTable rows={contents} />
				</div>
				<div className={styles.mobileView}>
					{contents?.map((item, index) => (
						<div key={item.entry_id + ' ' + index} className={styles.rssMobileBox}>
							<h3>{item.filing_date}</h3>
							<h4>{item.title}</h4>
							<p>{item.summary}</p>
							<a href={item.link}>
								<span>{t('IR_landing_download_view')}</span>
							</a>
						</div>
					))}
				</div>
			</div>
			<button
				type="button"
				className={combineCN(styles.show_more_btn, 'd-flex f-center')}
				onClick={() => {
					window.open(SEC_FILINGS_URL, '_blank');
				}}
			>
				{t('show_more')}
			</button>
		</section>
	);
}
